export default class Notification {
  constructor() {
    this.init();
  }
  init() {
    const notifications = $(".esf-notifications");
    const close = $(".esf-notification__close");

    notifications.appendTo(".esf-main-layout");

    close.click(function() {
      $(this)
        .parent()
        .removeClass("is-active");
    });
  }
}
